import React, { useState, useEffect } from "react";
import { AdminLayout } from "../layout/AdminLayout";
import { rolesService } from "../../services/rolesService";
import { skillsService } from "../../services/skillsService";
import { categoriesService } from "../../services/categoriesService";
import { resourcesService } from "../../services/resourcesService";
import { contactsService } from "../../services/contactsService";
import { inquiriesService } from "../../services/inquiriesService";
import { toast } from "react-toastify";
import { Briefcase, Code, Layers, Users, Mail, FileText } from "lucide-react";

export const Dashboard = () => {
	const [counts, setCounts] = useState({
		roles: 0,
		skills: 0,
		categories: 0,
		resources: 0,
		contacts: 0,
		inquiries: 0,
	});
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		loadCounts();
	}, []);

	const loadCounts = async () => {
		try {
			const [
				rolesData,
				skillsData,
				categoriesData,
				resourcesData,
				contactsData,
				inquiriesData,
			] = await Promise.all([
				rolesService.getAll(1, 1),
				skillsService.getAll(1, 1),
				categoriesService.getAll(1, 1),
				resourcesService.getAll(1, 1),
				contactsService.getAll(1, 1),
				inquiriesService.getAll(1, 1),
			]);

			setCounts({
				roles: rolesData.total || 0,
				skills: skillsData.total || 0,
				categories: categoriesData.total || 0,
				resources: resourcesData.total || 0,
				contacts: contactsData.total || 0,
				inquiries: inquiriesData.total || 0,
			});
		} catch (error) {
			console.log("Error loading dashboard counts:", error);
			toast.error("Failed to load dashboard data");
		} finally {
			setLoading(false);
		}
	};

	const cards = [
		{
			title: "Roles",
			count: counts.roles,
			icon: Briefcase,
			color: "bg-blue-500",
			link: "/admin/roles",
		},
		{
			title: "Skills",
			count: counts.skills,
			icon: Code,
			color: "bg-green-500",
			link: "/admin/skills",
		},
		{
			title: "Categories",
			count: counts.categories,
			icon: Layers,
			color: "bg-purple-500",
			link: "/admin/categories",
		},
		{
			title: "Resources",
			count: counts.resources,
			icon: Users,
			color: "bg-orange-500",
			link: "/admin/resources",
		},
		{
			title: "Contacts",
			count: counts.contacts,
			icon: Mail,
			color: "bg-emerald-500",
			link: "/admin/contacts",
		},
		{
			title: "Inquiries",
			count: counts.inquiries,
			icon: FileText,
			color: "bg-indigo-500",
			link: "/admin/inquiries",
		},
	];

	if (loading) {
		return (
			<AdminLayout>
				<div className="p-6 flex items-center justify-center h-full">
					<div className="text-gray-500">Loading dashboard...</div>
				</div>
			</AdminLayout>
		);
	}

	return (
		<AdminLayout>
			<div className="p-6">
				<h1 className="text-4xl font-bold text-gray-800 mb-8">Dashboard</h1>

				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
					{cards.map((card) => {
						const Icon = card.icon;
						return (
							<a
								key={card.title}
								href={card.link}
								className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow p-6 border-t-4"
								style={{
									borderTopColor: card.color.split("-")[1] === "500" ? "#" : "",
								}}
							>
								<div className="flex items-center justify-between">
									<div>
										<p className="text-gray-600 text-sm font-medium">
											{card.title}
										</p>
										<p className="text-4xl font-bold text-gray-800 mt-2">
											{card.count}
										</p>
									</div>
									<div className={`${card.color} rounded-lg p-4 text-white`}>
										<Icon size={32} />
									</div>
								</div>
							</a>
						);
					})}
				</div>
			</div>
		</AdminLayout>
	);
};
